(function () {
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  const formatMoney = (cents) => {
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, window.KeloTheme.moneyFormat);
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100);
  };

  const escapeHTML = (value) => String(value || '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  }[char]));

  window.addEventListener('load', () => qs('[data-loader]')?.classList.add('is-hidden'));

  const header = qs('.site-header');
  const progress = qs('[data-scroll-progress]');
  const onScroll = () => {
    const y = window.scrollY;
    header?.classList.toggle('is-scrolled', y > 24);
    if (progress) {
      const max = document.documentElement.scrollHeight - innerHeight;
      progress.style.width = `${Math.min(100, (y / max) * 100)}%`;
    }
    qs('.sticky-atc')?.classList.toggle('is-visible', y > 680);
  };
  document.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  if (!prefersReduced && window.Lenis && document.body.className.includes('motion') && true) {
    const lenis = new Lenis({ lerp: 0.08, smoothWheel: true });
    function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);
  }

  const isDesignMode = () => Boolean(window.Shopify && Shopify.designMode);

  const initMotion = (root = document) => {
    const revealItems = qsa('[data-reveal]', root);
    if (prefersReduced || !window.gsap || isDesignMode()) {
      revealItems.forEach((el) => { el.style.opacity = 1; el.style.transform = 'none'; });
      return;
    }
    if (window.ScrollTrigger) gsap.registerPlugin(ScrollTrigger);
    revealItems.forEach((el) => {
      if (el.dataset.revealInit) return;
      el.dataset.revealInit = 'true';
      gsap.to(el, { opacity: 1, y: 0, duration: .9, ease: 'power3.out', scrollTrigger: { trigger: el, start: 'top 86%' } });
    });
    qsa('[data-parallax]', root).forEach((el) => {
      if (el.dataset.parallaxInit) return;
      el.dataset.parallaxInit = 'true';
      gsap.to(el, { yPercent: -10, ease: 'none', scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: true } });
    });
  };

  document.addEventListener('pointermove', (event) => {
    const cursor = qs('[data-cursor]');
    if (!cursor || prefersReduced || !true) return;
    cursor.style.opacity = '1';
    cursor.style.left = `${event.clientX}px`;
    cursor.style.top = `${event.clientY}px`;
  }, { passive: true });

  const initProductSliders = (root = document) => qsa('.product-slider .swiper', root).forEach((el) => {
    if (!window.Swiper) {
      const attempts = Number(el.dataset.swiperWait || 0);
      if (attempts < 20) {
        el.dataset.swiperWait = String(attempts + 1);
        window.setTimeout(() => initProductSliders(root), 120);
      }
      return;
    }
    delete el.dataset.swiperWait;
    if (el.swiper && !el.swiper.destroyed) {
      el.swiper.update();
      return;
    }
    const section = el.closest('.best-sellers');
    new Swiper(el, {
      slidesPerView: 1.18,
      spaceBetween: 16,
      grabCursor: true,
      navigation: {
        prevEl: qs('[data-slider-prev]', section || document),
        nextEl: qs('[data-slider-next]', section || document)
      },
      breakpoints: { 700: { slidesPerView: 2.4 }, 990: { slidesPerView: 3.4 }, 1280: { slidesPerView: 4.2 } }
    });
  });

  const initTestimonialSliders = (root = document) => qsa('[data-testimonial-slider]', root).forEach((el) => {
    if (!window.Swiper) {
      const attempts = Number(el.dataset.swiperWait || 0);
      if (attempts < 20) {
        el.dataset.swiperWait = String(attempts + 1);
        window.setTimeout(() => initTestimonialSliders(root), 120);
      }
      return;
    }
    delete el.dataset.swiperWait;
    if (el.swiper && !el.swiper.destroyed) {
      el.swiper.update();
      return;
    }
    const section = el.closest('.testimonials-section');
    new Swiper(el, {
      slidesPerView: 1.05,
      spaceBetween: 16,
      centeredSlides: false,
      grabCursor: true,
      loop: qsa('.swiper-slide', el).length > 2,
      autoplay: isDesignMode() ? false : { delay: 3600, disableOnInteraction: false, pauseOnMouseEnter: true },
      navigation: {
        prevEl: qs('[data-slider-prev]', section || document),
        nextEl: qs('[data-slider-next]', section || document)
      },
      pagination: {
        el: qs('[data-slider-pagination]', section || document),
        clickable: true
      },
      breakpoints: {
        700: { slidesPerView: 2, spaceBetween: 18 },
        1100: { slidesPerView: 3, spaceBetween: 20 }
      }
    });
  });

  const initComparisons = (root = document) => qsa('[data-comparison]', root).forEach((wrap) => {
    if (wrap.dataset.comparisonInit) return;
    wrap.dataset.comparisonInit = 'true';
    const input = qs('input[type="range"]', wrap);
    const after = qs('.comparison__after', wrap);
    const handle = qs('.comparison__handle', wrap);
    const update = () => {
      if (!input || !after || !handle) return;
      const value = input.value;
      wrap.style.setProperty('--position', `${value}%`);
    };
    input?.addEventListener('input', update);
    update();
  });

  const initTheme = (root = document) => {
    initMotion(root);
    initProductSliders(root);
    initTestimonialSliders(root);
    initComparisons(root);
    updateBundleTotal();
    if (window.ScrollTrigger && ScrollTrigger.refresh) ScrollTrigger.refresh();
  };

  window.addEventListener('load', () => initTheme());
  document.addEventListener('shopify:section:load', (event) => initTheme(event.target));

  document.addEventListener('click', (event) => {
    const openCart = event.target.closest('[data-cart-open]');
    const closeCart = event.target.closest('[data-cart-close]');
    if (openCart) {
      event.preventDefault();
      qs('[data-cart-drawer]')?.classList.add('is-open');
      qs('[data-cart-drawer]')?.setAttribute('aria-hidden', 'false');
      refreshCart();
    }
    if (closeCart) {
      qs('[data-cart-drawer]')?.classList.remove('is-open');
      qs('[data-cart-drawer]')?.setAttribute('aria-hidden', 'true');
    }
    const searchOpen = event.target.closest('[data-search-open]');
    const searchClose = event.target.closest('[data-search-close]');
    if (searchOpen) qs('[data-predictive-search]')?.classList.add('is-open');
    if (searchClose || event.target.matches('[data-predictive-search]')) qs('[data-predictive-search]')?.classList.remove('is-open');
    if (event.target.closest('[data-mobile-menu-open]')) {
      qs('[data-mobile-menu]')?.classList.add('is-open');
      qs('[data-mobile-menu]')?.setAttribute('aria-hidden', 'false');
    }
    if (event.target.closest('[data-mobile-menu-close]')) {
      qs('[data-mobile-menu]')?.classList.remove('is-open');
      qs('[data-mobile-menu]')?.setAttribute('aria-hidden', 'true');
    }
    const bundleButton = event.target.closest('[data-bundle-item] > button');
    if (bundleButton) {
      const item = bundleButton.closest('[data-bundle-item]');
      item.classList.toggle('is-off');
      bundleButton.setAttribute('aria-pressed', item.classList.contains('is-off') ? 'false' : 'true');
      updateBundleTotal();
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-quick-add], .product-form');
    if (!form || !window.KeloTheme) return;
    event.preventDefault();
    const button = qs('button[type="submit"]', form);
    button?.setAttribute('disabled', 'disabled');
    try {
      await fetch(window.KeloTheme.routes.cart_add_url + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
      await refreshCart();
      qs('[data-cart-drawer]')?.classList.add('is-open');
      qs('[data-cart-drawer]')?.setAttribute('aria-hidden', 'false');
    } catch (err) {
      console.error(err);
    } finally {
      button?.removeAttribute('disabled');
    }
  });

  async function refreshCart() {
    const cart = await fetch('/cart.js').then((r) => r.json());
    const subtotal = qs('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    qsa('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
    renderCartItems(cart);
    const shipping = qs('[data-free-shipping]');
    if (shipping) {
      const threshold = Number(shipping.dataset.threshold || 0);
      const percent = threshold ? Math.min(100, cart.total_price / threshold * 100) : 100;
      qs('[data-free-shipping-bar]', shipping).style.width = `${percent}%`;
      qs('[data-free-shipping-text]', shipping).textContent = cart.total_price >= threshold ? 'Free shipping unlocked' : `${formatMoney(threshold - cart.total_price)} away from free shipping`;
    }
  }
  refreshCart();

  function renderCartItems(cart) {
    const wrap = qs('[data-cart-items]');
    if (!wrap) return;
    if (!cart.items.length) {
      wrap.innerHTML = `<p class="cart-drawer__empty">Your ritual is waiting.</p>`;
      return;
    }
    wrap.innerHTML = cart.items.map((item, index) => {
      const title = escapeHTML(item.product_title);
      const image = item.image ? '<img class="cart-item__image" src="' + escapeHTML(item.image) + '" alt="' + title + '" loading="lazy">' : '';
      return '<article class="cart-item" data-line="' + (index + 1) + '">' +
        image +
        '<div>' +
          '<h3>' + title + '</h3>' +
          '<p>' + formatMoney(item.final_line_price) + '</p>' +
          '<div class="quantity">' +
            '<button type="button" data-cart-qty="' + (index + 1) + '" data-delta="-1" aria-label="Decrease quantity">-</button>' +
            '<input class="quantity__input" value="' + Number(item.quantity || 0) + '" readonly aria-label="Quantity">' +
            '<button type="button" data-cart-qty="' + (index + 1) + '" data-delta="1" aria-label="Increase quantity">+</button>' +
          '</div>' +
        '</div>' +
      '</article>';
    }).join('');
  }

  document.addEventListener('click', async (event) => {
    const qty = event.target.closest('[data-cart-qty]');
    if (!qty) return;
    const line = Number(qty.dataset.cartQty);
    const item = qs(`[data-line="${line}"] .quantity__input`);
    const quantity = Math.max(0, Number(item?.value || 1) + Number(qty.dataset.delta));
    await fetch(window.KeloTheme.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    await refreshCart();
  });

  function updateBundleTotal() {
    const active = qsa('[data-bundle-item]:not(.is-off)');
    const cents = active.reduce((sum, item) => sum + Number(item.dataset.price || 0), 0);
    const total = qs('[data-bundle-total]');
    if (total) total.textContent = `${formatMoney(cents)} selected`;
  }
  updateBundleTotal();

  let searchTimer = null;
  document.addEventListener('input', (event) => {
    const input = event.target.closest('[data-predictive-search] input[type="search"]');
    if (!input) return;
    clearTimeout(searchTimer);
    searchTimer = setTimeout(async () => {
      const results = qs('[data-search-results]');
      const q = input.value.trim();
      if (!results) return;
      if (q.length < 3) {
        results.innerHTML = q ? '<p class="search-hint">Type at least 3 letters to find products.</p>' : '';
        return;
      }
      try {
        const url = `${window.KeloTheme.routes.predictive_search_url}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor`;
        const data = await fetch(url, { headers: { 'Accept': 'application/json' } }).then((r) => r.json());
        const products = data.resources?.results?.products || [];
        results.innerHTML = products.length ? products.map((product) => {
          return '<a class="search-result" href="' + escapeHTML(product.url) + '">' +
            '<img src="' + escapeHTML(product.image || '') + '" alt="" loading="lazy">' +
            '<span><strong>' + escapeHTML(product.title) + '</strong><span>' + escapeHTML(product.vendor || 'Kelo Hair Growth') + '</span></span>' +
            '<span>' + escapeHTML(product.price || '') + '</span>' +
          '</a>';
        }).join('') : '<p>No results found</p>';
      } catch (err) {
        console.error(err);
      }
    }, 180);
  });

  if (!customElements.get('quantity-input')) {
    customElements.define('quantity-input', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const btn = event.target.closest('button');
          if (!btn) return;
          const input = qs('input', this);
          const delta = btn.name === 'plus' ? 1 : -1;
          input.value = Math.max(Number(input.min || 1), Number(input.value || 1) + delta);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
    });
  }
})();
